import logoWhite from 'assets/Name - White Transparent.svg'
import { NavMenu } from '../NavMenu'
import * as S from './styles'

export function UnauthenticatedNav() {
  return (
    <S.Wrapper>
      <img src={logoWhite} alt="First Bite" className="h-[45px]" />
      <NavMenu
        items={[
          {
            label: 'Login',
            to: '/login',
          },
        ]}
      />
    </S.Wrapper>
  )
}
